import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  AUTO_SPLIT: "blue",
  COORDINATOR_REVIEW: "amber",
  MANAGER_ESCALATION: "red",
  NONE: "green",
}

/** Decision of the shortage evaluation: dot + dark text (no coloured fill or border). */
export function DecisionBadge({ decision }: Readonly<{ decision: string | null | undefined }>) {
  const { t } = useTranslation("delivery")
  if (!decision) return <>-</>
  return <DotPill tone={TONES[decision] ?? "grey"}>{t(`shortage.decision.${decision}`, { defaultValue: "-" })}</DotPill>
}
